module.exports = __webpack_public_path__ + "60f12f643c38d4125e02b5934133a36d.png";